import { GridRowSelectionModel } from "@mui/x-data-grid-premium";
import { useFormik } from "formik";
import { useState } from "react";
import { Button, DataGrid, Grid, TextField } from "src/components"
import Autocomplete from "src/components/Autocomplete";
import ParametreGrupEnum from "src/enums/ParametreGrupEnum";
import { translate } from "src/i18n/tHelper";
import GnlMailOntanimlarDTO from "src/models/Mail/GnlMailOntanimlarDTO";
import { OrganizasyonMailApi, useGnlMailOntanimlarEkleMutation, useGnlMailOntanimlarGetirQuery, useGnlMailOntanimlarGuncelleMutation } from "src/services/OrganizasyonTanim/OrganizasyonMailApi"
import { useAppDispatch, useAppSelector } from "src/store";
import MailGonderimAutocomplete from "./MailGonderimAutocomplete";
import GnlKullaniciAyarDTO from "src/models/Base/Auth/GnlKullaniciAyarDTO";

const MailOnTanimlar = (): JSX.Element => {
    const organizasyon = useAppSelector(s => s.userOrganizasyon.organizasyon)
    const query = useGnlMailOntanimlarGetirQuery({
        organizasyonId: organizasyon.fkOrganizasyon
    }, { skip: !organizasyon.fkOrganizasyon });
    const parametre = useAppSelector(s => s.parameters.data)
    const [selectedRows, setSelectedRows] = useState<GridRowSelectionModel>([1])
    const [ekle, ekleState] = useGnlMailOntanimlarEkleMutation()
    const [guncelle, guncelleState] = useGnlMailOntanimlarGuncelleMutation()
    const dispatch = useAppDispatch()
    const formik = useFormik({
        validateOnChange: false,
        enableReinitialize: true,
        initialValues: query.data?.find(f => f.mailTipId === selectedRows[0] as number) || {
            ...new GnlMailOntanimlarDTO(),
            mailTipId: selectedRows[0] as number,
            organizasyonId: organizasyon.fkOrganizasyon
        },
        onSubmit(values, formikHelpers) {
            if (values.id > 0)
                guncelle(values).unwrap()
                    .then(res => {
                        dispatch(OrganizasyonMailApi.util.updateQueryData("gnlMailOntanimlarGetir",
                            {
                                organizasyonId: organizasyon.fkOrganizasyon
                            },
                            draft => {
                                return draft.map(m => {
                                    if (m.id === values.id)
                                        return values
                                    return m
                                })
                            }))
                    });
            else ekle(values).unwrap()
                .then(res => {
                    dispatch(OrganizasyonMailApi.util.updateQueryData("gnlMailOntanimlarGetir",
                        {
                            organizasyonId: organizasyon.fkOrganizasyon
                        },
                        draft => {
                            draft.unshift(res)
                            return draft
                        }))
                });
        },
    })

    return (
        <Grid container>
            <Grid item md={4}>
                <DataGrid
                    rows={parametre.filter(f => f.grupId === ParametreGrupEnum.MailTipleri) || []}
                    columns={[
                        { field: "value", headerName: "Mail Tipi", flex: 1 }
                    ]}
                    sx={{
                        height: 400
                    }}
                    rowSelectionModel={selectedRows}
                    disableMultipleRowSelection
                    getRowId={(row) => row.key}
                    onRowSelectionModelChange={(e) => {
                        setSelectedRows(e)
                    }}
                />
            </Grid>
            <Grid item md={8}>
                <Grid container>
                    <Grid item>
                        <TextField
                            label={translate("pages|hastaServis|order|mailOnTanimlari", "Konu")}
                            value={formik.values.konu}
                            name="konu"
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item>
                        <MailGonderimAutocomplete
                            label={translate("pages|hastaServis|order|mailOnTanimlari", "Bilgi")}
                            value={formik.values.bilgi ? formik.values.bilgi.split(";").map(m => {
                                return {
                                    ayar: m
                                }
                            }) : []}
                            onChange={(v) => {
                                formik.setValues({
                                    ...formik.values,
                                    bilgi: v?.map(m => m.ayar).join(";")
                                })
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            label={translate("pages|hastaServis|order|mailOnTanimlari", "İçerik")}
                            value={formik.values.icerik}
                            name="icerik"
                            onChange={formik.handleChange}
                            multiline
                            rows={5}
                        />
                    </Grid>
                    <Grid item>
                        <Grid container justifyContent={"right"}>
                            <Grid item sm={6} md={4} lg={3}>
                                <Button
                                    customType="save"
                                    loading={guncelleState.isLoading || ekleState.isLoading}
                                    disabled={!formik.dirty}
                                    onClick={formik.submitForm}
                                ></Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>

    )
}
export default MailOnTanimlar;